module.exports = ".regular-savings-plan-title {\r\n  margin-top: 15px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.horizontal-center {\r\n  text-align: center;\r\n  display: block;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/my-financial/my-capital-needs/my-capital-needs.component.css
// module id = ./src/app/features/my-financial/my-capital-needs/my-capital-needs.component.css
// module chunks = main